import React, { useEffect, useState } from 'react'
import '../../Assets/Css/Employeeprofile.scss'
import ProfileIcon from "../../Assets/Images/Dashboard/user-icon.svg"
import MyTaskListIcon from "../../Assets/Images/Employee/employee_details.svg"
import EmployeeAppreciationIcon from "../../Assets/Images/Dashboard/EmployeeAppreciationIcon.svg"
import TaskDetailIcon from "../../Assets/Images/Dashboard/TaskDetailIcon.svg"
import LateAttendance from "../../Assets/Images/Attendance/late-attendance.svg"
import WeekTimelogsIcon from "../../Assets/Images/Dashboard/WeekTimelogsIcon.svg"
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Chart from '../../Components/Chart'
import Table from '../../Components/Table'
import { connect } from 'react-redux'
import { Avatar } from 'antd'
import { getUsers } from '../../Services/Users/action'
import { getAppreciations } from '../../Services/Appreciation/action'
import moment from 'moment'
import { getIconComponent } from '../../Lib/utils'
import { FaMedal, FaUserCircle } from 'react-icons/fa'
import { getTasks } from '../../Services/Task/action'
import UserAvatar from 'react-user-avatar'
import { getLeaves } from '../../Services/Leave/action'
const EmployeeProfile = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [employee, setEmployee] = useState({});
    const [inData, setInData] = useState([]);
    const [totalTakenLeaves, setTotalTakenLeaves] = useState(0);
    const location = useLocation();
    const { employeeId } = useParams();
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const navigate = useNavigate()

    const handlenavigate = () => {
        navigate('/employees/edit', {
            state: {
                data: {
                    allData: employee
                }
            }
        });
    };

    const fetchData = async () => {
        await props?.getAppreciations();
        await props?.getLeaves();
    }

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        if (location?.state?.data?.allData) {
            setEmployee(location.state.data.allData);
        } else {
            if (props?.users?.length) {
                const matchedUser = props.users.find(user => user.id === employeeId || user.id === parseInt(employeeId));
                if (matchedUser) {
                    setEmployee(matchedUser);
                }
            } else {
                props?.getUsers({ module: 'employees' });
            }
        }
    }, [location?.state, props?.users]);


    const header = [
        { field: "Late Timing" },
        { field: "Date" }
    ];

    useEffect(() => {
        const user = props?.users?.find(item => item?.id === employeeId);
        const attendance = user?.attendance;

        if (!Array.isArray(attendance)) return;

        const lateTime = moment('11:00', 'HH:mm');

        const groupedByDate = attendance.reduce((acc, entry) => {
            const date = moment(entry?.date).format('YYYY-MM-DD');
            if (!acc[date]) acc[date] = [];
            acc[date].push(entry);
            return acc;
        }, {});

        const lateAttendance = Object.entries(groupedByDate).map(([date, entries]) => {
            const earliest = entries.reduce((minEntry, current) => {
                const currentClockIn = moment(current.clock_in, 'HH:mm');
                const minClockIn = moment(minEntry.clock_in, 'HH:mm');
                return currentClockIn.isBefore(minClockIn) ? current : minEntry;
            });

            const clockIn = moment(earliest.clock_in, 'HH:mm');
            const formattedDate = moment(date).format('DD-MM-YYYY');

            if (clockIn.isAfter(lateTime)) {
                const diffMinutes = clockIn.diff(lateTime, 'minutes');
                const hours = Math.floor(diffMinutes / 60);
                const minutes = diffMinutes % 60;
                const lateBy = `${hours}h ${minutes.toString().padStart(2, '0')}min`;

                return {
                    "Late Timing": {
                        late_value: lateBy,
                        type: 'text'
                    },
                    Date: {
                        value: formattedDate,
                        type: 'date'
                    }
                };
            }

            return null;
        }).filter(Boolean);

        setInData(lateAttendance);
    }, [props?.users]);

useEffect(() => {
    let totalCasualTakenFromBackend = 0;
    const employeeLeaves = props?.leaves?.filter(l => l?.employee_id == employee?.id);
    const firstLeaveRecord = employeeLeaves?.[0];
    if (firstLeaveRecord && firstLeaveRecord?.totalCasualTaken !== undefined) {
        totalCasualTakenFromBackend = parseFloat(firstLeaveRecord.totalCasualTaken) || 0;
    }
    const employeeUnpaidLeave = parseFloat(employee?.unpaid_leave || 0);
    const totalTaken = totalCasualTakenFromBackend + employeeUnpaidLeave;
    setTotalTakenLeaves(totalTaken);
    
}, [props?.leaves, employee?.id, props?.user?.unpaid_leave]);


    const currentUser = props?.users?.find(
        (user) => user?.id === props?.user?.id
    );

    const unpaidLeave = parseFloat(currentUser?.unpaid_leave) || 0;
    const casualLeave = parseFloat(currentUser?.casual_leave) || 0;
    const employeeLeaveRecord = props.leaves?.find(leave => leave.employee_id === employee?.id);
    const totalCasualTaken = parseFloat(employeeLeaveRecord?.totalCasualTaken) || 0;
    const takenLeave = parseFloat(unpaidLeave + totalCasualTaken) || 0;
    const remainingLeave = employee?.casual_leave;


    const getWeekTimeLogs = () => {
        const weekStart = moment().startOf('week').add(1, 'day');
        const weekEnd = moment().endOf('week').add(1, 'day');

        let totalSeconds = 0;

        props?.task?.filter(item => item?.taskUserMap?.some(userMap => userMap?.user_id === employee?.id))?.forEach(task => {
            task.taskTimerMap?.forEach(timer => {
                const start = moment(timer?.start_time);
                const stop = moment(timer?.stop_time);

                const withinWeek =
                    (stop.isValid() && stop.isBetween(weekStart, weekEnd, null, '[]')) ||
                    (start.isValid() && start.isBetween(weekStart, weekEnd, null, '[]'));

                if (withinWeek && timer?.duration) {
                    const parts = timer.duration.match(/(\d+)h\s*(\d+)m\s*(\d+)s/);
                    if (parts) {
                        const [, h, m, s] = parts.map(Number);
                        totalSeconds += h * 3600 + m * 60 + s;
                    }
                }
            });
        });

        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };

    const getCurrentWeekTaskAndTimerStats = () => {
        const startOfWeek = moment().startOf('isoWeek');
        const endOfWeek = moment().endOf('isoWeek');
        const currentYear = moment().year();

        const weekStats = Array(7).fill(null).map((_, i) => ({
            name: moment(startOfWeek).add(i, 'days').format('ddd'),
            Task: 0,
            Timer: 0
        }));

        props?.task
            ?.filter(item =>
                item?.taskUserMap?.some(userMap => userMap?.user_id === employee?.id)
            )
            ?.forEach(taskItem => {
                const createdAt = moment(taskItem.createdAt);
                if (
                    createdAt.isValid() &&
                    createdAt.isoWeek() === startOfWeek.isoWeek() &&
                    createdAt.year() === currentYear
                ) {
                    const taskDayIndex = createdAt.isoWeekday() - 1;
                    if (taskDayIndex >= 0 && taskDayIndex < 7) {
                        weekStats[taskDayIndex].Task += 1;
                    }
                }

                taskItem?.taskTimerMap?.forEach(timer => {
                    const start = moment(timer?.start_time);
                    const stop = moment(timer?.stop_time);

                    const validTime = stop.isValid() ? stop : start;
                    if (!validTime.isValid()) return;

                    if (
                        validTime.isBetween(startOfWeek, endOfWeek, null, '[]') &&
                        timer?.duration
                    ) {
                        const parts = timer.duration.match(/(?:(\d+)h)?\s*(?:(\d+)m)?\s*(?:(\d+)s)?/i);
                        if (parts) {
                            const [, h = 0, m = 0, s = 0] = parts.map(p => parseInt(p) || 0);
                            const totalSeconds = h * 3600 + m * 60 + s;
                            const totalMinutes = totalSeconds / 60;

                            const dayIndex = validTime.isoWeekday() - 1;
                            if (dayIndex >= 0 && dayIndex < 7) {
                                weekStats[dayIndex].Timer += totalMinutes;
                            }
                        }
                    }
                });
            });

        return weekStats.map(day => ({
            ...day,
            Timer: Math.round(day.Timer)
        }));
    };

    return (
        <div className='profile-container'>
            <div className='row'>
                <div className='col-lg-6 profile-left-part'>
                    <div className='profile common-card'>
                        <div className='row'>
                            <div className='col-lg-4 col-md-4 col-sm-6'>
                                <div className='image-part'>
                                    {employee?.profile_pic ? (
                                        <img
                                            src={`data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(employee?.profile_pic?.data)))}`}
                                            alt="image"
                                        />
                                    ) : (
                                        <UserAvatar name={employee?.name || "CD"} size={150} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />

                                        // <FaUserCircle size={150} color="rgb(180, 180, 180)" />
                                        // <Avatar size={150} shape="square" style={{ fontSize: '30px' }}>{employee?.name?.split(" ")[0][0] + employee?.name?.split(" ")[1][0]}</Avatar>
                                    )}
                                </div>

                            </div>
                            <div className='col-lg-8 col-md-8 col-sm-6'>
                                <div className='employee-information'>
                                    <div className='employee-name'>
                                        <p>{employee?.name}</p>
                                    </div>
                                    <div className='employee-other-information'>
                                        <p><span>{employee?.designation?.name}</span></p>
                                        <p><span>{employee?.employee_code}</span></p>
                                        <p><span>{employee?.email}</span></p>
                                    </div>
                                    <div className='employee-edit-button'>
                                        <button
                                            className='custom-btn'
                                            onClick={handlenavigate}>
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='menu-button'>
                            <img src={ProfileIcon} alt="" className="more-icon"
                            // data-bs-toggle="dropdown"
                            // onClick={toggleDropdown}
                            // aria-expanded={isOpen}
                            />
                            {/* {isOpen && (
                                <div className="dropdown-menu show">
                                    <div className="d-grid">
                                        <button
                                            className="dropdown-item"
                                            onClick={handlenavigate}
                                        >
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            )} */}
                        </div>
                    </div>

                    <div className='profile-information-part common-card'>
                        <div className='profile-heading'>
                            <span>Profile info</span>
                            <img src={MyTaskListIcon} />
                        </div>
                        <div className='employee-profile-info '>
                            <div className='card-row row row'><p className='col-6'>Full Name</p><p className='col-6'>{employee?.name || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Employee Code</p><p className='col-6'>{employee?.employee_code || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>company Email</p><p className='col-6'>{employee?.email || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>personal email</p><p className='col-6'>{employee?.personal_email || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Skills</p><p className='col-6'>{employee?.skills || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Department</p><p className='col-6'>{employee?.department?.name || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Designation</p><p className='col-6'>{employee?.designation?.name || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Employee type</p><p className='col-6'>{employee?.employee_type || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>mobile number</p><p className='col-6'>{employee?.mobile || '-'}</p></div>
                            <div className='card-row row'><p>Gender</p><p className='col-6'>{employee?.gender || '-'}</p></div>
                            <div className='card-row row'><p>Address</p><p className='col-6'>{employee?.address || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Permanent Address</p><p className='col-6'>{employee?.permanent_address || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>date of birth</p><p className='col-6'>{employee?.date_of_birth?.split(" ")[0] || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>marital status</p><p className='col-6'>{employee?.marital_status || '-'}</p></div>
                            {
                                employee?.marital_status === "Married" && (
                                    <div className='card-row row'><p className='col-6'>marriage anniversary</p><p className='col-6'>{employee?.marriage_anniversary_date?.split(" ")[0] || '-'}</p></div>
                                )
                            }
                            <div className='card-row row'><p className='col-6'>joining date</p><p className='col-6'>{employee?.joining_date?.split(" ")[0] || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Probation Period End Date</p><p className='col-6'>{employee?.probation_period_end_date?.split(" ")[0] || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>notice period start date</p><p className='col-6'>{employee?.notice_period_start_date?.split(" ")[0] || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>notice period end date</p><p className='col-6'>{employee?.notice_period_end_date?.split(" ")[0] || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>slack ID</p><p className='col-6'>{employee?.slack_id || '-'}</p></div>
                            <div className='card-row row'><p className='col-6' >work anniversary Date</p><p className='col-6'>{employee?.work_anniversary_date?.split(" ")[0] || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>emergency contact</p><p className='col-6'>{employee?.emergency_contact || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Relation with emergency contact </p><p className='col-6'>{employee?.emergency_contact_relationship || '-'}</p></div>
                            <div className='card-row row'><p className='col-6'>Name of emergency contact</p><p className='col-6'>{employee?.emergency_contact_name || '-'}</p></div>

                        </div>

                    </div>

                </div>
                <div className='col-lg-6 profile-right-part'>

                    <div className='common-card'>
                        <div className='profile-heading'>
                            <span>Employee Appreciations</span>
                            <img src={EmployeeAppreciationIcon} />
                        </div>

                        {employee?.appreciation?.length > 0 ? (

                            employee?.appreciation?.map((appr) => {
                                const Icon = getIconComponent(appr?.award?.icon);
                                return (
                                    <div className="appreciation-part">
                                        <div className="award-image"
                                            style={{
                                                backgroundColor: appr?.award?.icon_background_color || '#eee',
                                                width: 40,
                                                height: 40,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#fff',
                                                fontSize: 20,
                                            }}>
                                            <Icon />
                                        </div>
                                        <div className="award-details">
                                            <h3 className="award-name">{appr?.award?.title}</h3>
                                            <div className="award-date">
                                                {moment(appr?.date)?.format('DD-MM-YYYY')}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })

                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '150px',
                                    color: 'gray',
                                    textAlign: 'center',
                                }}
                            >
                                <FaMedal size={30} color="gray" />
                                <p style={{ marginTop: 10 }}>- No record found. -</p>
                            </div>

                        )}
                    </div>


                    <div className="attendace-part common-card">
                        <div className='profile-heading'>
                            <span>Late Attendance</span>
                            <img src={LateAttendance} />
                        </div>

                        <div className='late-time-info'>
                            <Table
                                header={header}
                                data={inData}
                                footer={false}
                            />
                        </div>
                    </div>


                    <div class="leave-part common-card">
                        <div className='profile-heading'>
                            <span>Leave Balance</span>
                            <img src={TaskDetailIcon} />
                        </div>
                        <div class="leave-bar">

                            <div class="taken-leave">
                                <p>Taken Leave</p>
                                <p>{totalTakenLeaves.toFixed(1) || 0.00}</p>
                            </div>

                            <div class="remaining-leave">
                                <p>Remaining Leave</p>
                                <p>{parseFloat(employee?.casual_leave || 0.00).toFixed(1)}</p>
                            </div>
                        </div>
                    </div>


                    <div className='common-card'>
                        <div className='profile-heading'>
                            <span>Week Timelogs</span>
                            <img src={WeekTimelogsIcon} />
                        </div>
                        <div className='timelog-text'>
                            <span>{getWeekTimeLogs()} This Week</span>
                        </div>
                        <div className="content-part">
                            <div className="chart-label">
                                <div className="label-1">
                                    <div className="label-circle-exp"></div>
                                    <div className="label-text-exp">Task</div>
                                </div>
                                <div className="label-1">
                                    <div className="label-circle-ear"></div>
                                    <div className="label-text-ear">Timer</div>
                                </div>
                            </div>
                            <div className="chart-content">
                                <Chart data={getCurrentWeekTaskAndTimerStats()} />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        users: state.userReducer.users,
        appreciation: state.appreciationReducer.appreciation,
        task: state.taskReducer.task,
        user: state.authenticationReducer.user,
        leaves: state.leaveReducer.leave
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: (options) => {
            dispatch(getUsers(options))
        },
        getAppreciations: () => {
            dispatch(getAppreciations())
        },
        getTasks: () => {
            dispatch(getTasks())
        },
        getLeaves: () => {
            dispatch(getLeaves());
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeProfile);